//@ts-check
import ACTIONS from '../../../store/actions';
import DataConfig from '../../../data';
import placeholders from '../../../data/placeholders';
import Utils from '../../../utils';
import itemSelector from '../../selectors/item';
import { runRequestHook, runResponseHook } from '../util';
export default (function (props) {
  return function (dispatch, getState) {
    var id = props.id,
        dataType = props.dataType;
    if (!id) return Promise.reject('Missing id ' + id);
    var dataConfig = dataType && DataConfig[dataType] && DataConfig[dataType].data;
    var itemUrl = '';

    if (dataConfig) {
      if (typeof dataConfig.itemUrl !== 'undefined') itemUrl = dataConfig.itemUrl;else if (dataConfig.url) itemUrl = dataConfig.url + '/{id}';
    }

    if (!itemUrl) return Promise.reject('Missing url for ' + dataType);
    /**@type {import('data/types').DataActionRequest} */

    var requestAction = {
      url: placeholders(itemUrl, props, null, true),
      type: 'loadItem'
    };
    var item = itemSelector(getState(), props);
    requestAction = runRequestHook(dataConfig.onBeforeRequest, props, requestAction, item, DataConfig[dataType]);
    var dataKey = DataConfig[dataType].data.dataKey;
    var idKeyProp = DataConfig[dataType].data.idKeyProp;
    var data = {
      dataKey: dataKey,
      idKeyProp: idKeyProp,
      id: id
    };
    return dispatch({
      type: ACTIONS.ITEM_GET,
      request: requestAction
    }).then(function (_ref) {
      var body = _ref.body,
          type = _ref.type,
          payload = _ref.payload;
      if (type === 'AUTH_SET_UNAUTHORIZED') throw payload;
      body = runResponseHook(dataConfig.onAfterResponse, props, requestAction, body, item, DataConfig[dataType]);
      return dispatch({
        type: ACTIONS.ITEM_GET_RESOLVED,
        payload: body,
        data: data,
        failed: false
      });
    }).catch(function (error) {
      return dispatch({
        type: ACTIONS.ITEM_GET_FAILED,
        payload: {
          error: error.message,
          text: Utils.getPrettyError(error),
          status: error.status
        },
        data: data,
        failed: true
      });
    });
  };
});